<div *ngIf="author && (author.name || author.friendlyName)"
     [class]="'z-1 relative ' + (blockClass ? (blockClass + ' ') : '') + theme.fullTheme + (block.class_overwrite ? (' ' + block.class_overwrite) : '' ) + ' ' + (componentOffset)">
    <div class="container m-auto relative overflow-hidden px-3 lg:px-0">
        <div [class]="'relative ' + (container ? 'md:px-6 lg:px-8 xl:!px-42' : '')"
             [ngClass]="{'py-7': theme.theme !== 'light'}">
            <div class="bg-orange-50 border-round-3xl px-4 py-4 md:px-6 lg:px-8 flex flex-column sm:flex-row gap-4 align-items-center justify-content-between">
                <div class="flex-1">
                    <p class="text-sm uppercase tracking-wide text-700 mt-0 mb-3">{{ authorLabel }}</p>

                    <div class="text-primary mb-4">
                        <p class="text-2xl md:text-3xl font-medium mt-0 mb-2">{{ author.name || author.friendlyName }}</p>
                        <p *ngIf="author.authorTitle" class="mt-0 mb-0">{{ author.authorTitle }}</p>
                    </div>

                    <p *ngIf="author.authorDescription" class="text-base line-height-3 mt-0 mb-0">
                        {{ author.authorDescription }}
                    </p>
                </div>

                <div *ngIf="author.photo?.url || author.linkedin" class="relative shrink-0">
                    <a *ngIf="author.linkedin"
                       [href]="author.linkedin"
                       class="absolute flex align-items-center justify-content-center border-circle no-underline text-white z-1"
                       rel="noreferrer noopener"
                       style="right: 0.75rem; top: 0; width: 3rem; height: 3rem; background-color: #0072B1;"
                       target="_blank">
                        <i class="pi pi-linkedin text-xl"></i>
                    </a>

                    <div class="overflow-hidden border-circle border-2 border-white shadow-4 bg-white flex align-items-center justify-content-center" style="width: 14rem; height: 14rem;">
                        <img *ngIf="author.photo?.url as photoUrl"
                             [src]="photoUrl"
                             [alt]="(author.name || author.friendlyName) + ' profile image'"
                             class="w-full h-full object-cover rounded-none">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
